<template>
    <div class="ccpay-Receipt">
        <div class="ccpay-Receipt-header">
            <span>接單</span>
        </div>
        <div class="ccpay-Receipt-content">
            <!-- 客户购买 -->
          <div class="ccpay-Receipt-card card-css">
            <p class="ccpay-Receipt-t-switch">
              <span>
                <span style="color:#68CEB9;margin-right:1rem;">客戶購買</span>
                <span style="font-weight:600">USDT</span>
              </span>
              <mt-switch :value.sync="open_buy" @change="buyflag"></mt-switch>
            </p>
            <p class="ccpay-Receipt-t-switch">
              <span>
                <span style="color:#68CEB9;margin-right:1rem;"><mt-switch :value.sync="accept_minority" @change="acceptMinority">偏遠地區</mt-switch></span>
                <span style="font-weight:600"></span>
              </span>
              <span>
                <span style="color:#68CEB9;margin-right:1rem;"><mt-switch :value.sync="all_day" @change="setAllDay  ">全天候</mt-switch></span>
                <span style="font-weight:600"></span>
              </span>
            </p>
            <p class="fz14" style="border-bottom:1px solid #eee;padding-bottom:1rem">
              <span>價格 ：{{buyPrice}} </span>
            </p>
            <p>
              <span>額度：{{Formatnumbers(available,4,'.',',')}}USDT</span>
            </p>
            <!-- <p>收款方式 </p>  -->
            <!-- <p v-show="item.account_type=='ALIPAY'" style="border-bottom:1px solid #eee;padding-bottom:1rem">
       <span>
           <span>支付寶帳號：</span>
           <span>{{item.user_id}}</span>
       </span>
       <img class="app-cell-allow-right" src="../../../static/icon/you.png">
   </p>  -->
            <!-- <p v-show="item.account_type=='BANKPAY'">
       <span>
           <span>銀行卡帳戶：</span>
           <span>{{item.platform_account_no}}</span>
           <span>{{item.bank_name}}</span>
       </span>
       <img class="app-cell-allow-right" src="../../../static/icon/you.png">
   </p>  -->
          </div>
            <!-- 客戶售出 -->
            <div class="ccpay-Receipt-card card-css">
               <p class="ccpay-Receipt-t-switch">
                   <span>
                       <span style="color:#E05C58;margin-right:1rem;">客戶售出</span> 
                       <span style="font-weight:600">USDT</span> 
                   </span> 
                    <mt-switch :value.sync="open_sell" @change="sellflag"></mt-switch></p> 
               <p class="fz14" style="padding-bottom:1rem">
                   <span>價格 ：{{sellPrice}} </span> 
                   <!-- <span style="color:#ccc">額度：9999USDT</span></p>  -->
            <!--    <p>设置单笔限額 </p> 
                  <p  class="ccpay-Receipt-card-ipt ">
                    <span>
                        <span><input v-model="bumber"/></span>
                        <span>CNY</span> 
                    </span> 
                </p> 
              <p >
                   只能接到客戶售出金额 {{fs}} {{bumber}} CNY 的訂單
                   </p> -->
                </p> 
            </div>
        </div>
       
        <!-- <mt-switch :value.sync="value"></mt-switch>
        Receipt -->
    </div>
</template>

<script>
  import { Formatnumbers } from '../../public/index.js'
  import { Switch } from 'mint-ui';
  import { Indicator } from 'mint-ui';
  export default {

    data() {
      return {
        value: false,
        fs: '<=',
        bumber: 0,
        databuy: [],
        open_buy: false, //1 开
        accept_minority: false,
        all_day: false,
        open_sell: false, // 0 关
        available: '',
        buyPrice: '',
        sellPrice: '',
        sell_order_max_amount: ''
      }
    },
    mounted() {
      Indicator.open();
      this.$axios.get('/v1/traders/open_order_status').then(res => {
        Indicator.close();
        if (res.code == 0) {
          this.getamount()
          this.open_buy = Boolean(res.data.is_open_buy)
          this.accept_minority = Boolean(res.data.accept_minority)
          this.all_day = Boolean(res.data.all_day)
          this.open_sell = Boolean(res.data.is_open_sell)
          this.buyPrice = res.data.buyPrice
          this.sellPrice = res.data.sellPrice
          this.bumber = res.data.sell_order_max_amount
        }
      })
    },
    methods: {
      Formatnumbers,
      getamount() {
        Indicator.open();
        this.$axios.get('/v1/account/amount?symbol=USDT').then(res => {
          Indicator.close();
          if (res.code == 0) {
            this.available = res.data.available
          }
        })
      },
      acceptMinority() {
        this.accept_minority = !this.accept_minority
        Indicator.open();
        if (this.accept_minority) {
          this.$axios.post('/v1/traders/accept_minority/set', {
            "enable": true
          }).then(res => {
            Indicator.close();
            if (res.code == 0) {
              this.$Toast('開啟支援偏遠地區成功')
            } else {
              this.accept_minority = false
              this.$Toast(res.msg)
              // console.log(res)
            }

          })
        } else {

          this.$axios.post('/v1/traders/accept_minority/set', {
            "enable": 0
          }).then(res => {
            Indicator.close();
            if (res.code == 0) {
              this.$Toast('關閉支援偏遠地區成功')
            } else {
              this.accept_minority = false
              this.$Toast(res.msg)
              // console.log(res)
            }
          })
        }

      },
      setAllDay() {
        this.all_day = !this.all_day
        Indicator.open();
        if (this.all_day) {
          this.$axios.post('/v1/traders/all_day/set', {
            "enable": true
          }).then(res => {
            Indicator.close();
            if (res.code == 0) {
              this.$Toast('開啟全天候接單成功')
            } else {
              this.all_day = false
              this.$Toast(res.msg)
              // console.log(res)
            }

          })
        } else {

          this.$axios.post('/v1/traders/all_day/set', {
            "enable": 0
          }).then(res => {
            Indicator.close();
            if (res.code == 0) {
              this.$Toast('關閉全天候接單成功')
            } else {
              this.all_day = false
              this.$Toast(res.msg)
              // console.log(res)
            }
          })
        }

      },
      buyflag() {
        this.open_buy = !this.open_buy
        Indicator.open();
        if (this.open_buy) {

          this.$axios.post('/v1/traders/buy_order_status/set', {
            "enable": true
          }).then(res => {
            Indicator.close();
            if (res.code == 0) {
              this.$Toast('开启买单接單成功')
            } else {
              this.open_buy = false
              this.$Toast(res.msg)
              // console.log(res)
            }

          })
        } else {

          this.$axios.post('/v1/traders/buy_order_status/set', {
            "enable": 0
          }).then(res => {
            Indicator.close();
            if (res.code == 0) {
              this.$Toast('关闭买单接單成功')
            } else {
              this.open_buy = false
              this.$Toast(res.msg)
              // console.log(res)
            }
          })
        }
        // console.log(this.open_buy)
      },
      sellflag() {
        this.open_sell = !this.open_sell
        // console.log(this.open_sell)
        Indicator.open();
        if (this.open_sell) {

          this.$axios.post('/v1/traders/sell_order_status/set', {
            "legal_currency_amount": this.bumber,
            "enable": true
          }).then(res => {
            Indicator.close();
            if (res.code == 0) {
              this.$Toast('开启卖单接單成功')
            } else {
              this.open_sell = false
              this.$Toast(res.msg)
              // console.log(res)
            }
          })
        } else {
          this.$axios.post('/v1/traders/sell_order_status/set', {
            "legal_currency_amount": this.bumber,
            "enable": 0
          }).then(res => {
            Indicator.close();
            if (res.code == 0) {
              this.$Toast('关闭卖单接單成功')
            } else {
              this.open_sell = false
              this.$Toast(res.msg)
              // console.log(res)
            }
          })
        }
      }
    }
  }
</script>

<style lang="scss" >

  #app {
    background-color: #bad5f9;
  }
  .ccpay-Receipt {
    background-color: #bad5f9;

    .card-css {
      color: #666666;
      margin-top: 24px;
      margin-bottom: 2rem;
      -webkit-transform: translateZ(0px);
      transform: translateZ(0px);
      font-size: 14px;
      -webkit-box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;
      box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;
      border-radius: 8px;
      transition: transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1) 0s, -webkit-transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1) 0s;
    }
    //  height: 100%;

    .ccpay-Receipt-header {
      font-weight: 500;
      border-bottom: 1px solid #ccc;
      padding-bottom: 0.2rem;
      position: fixed;
      top: 0;
      z-index: 999;
      height: 3rem;
      line-height: 3rem;
      width: 100%;
      background: white;
      display: flex;
      justify-content: space-around;
    }

    .ccpay-Receipt-content {
      margin-top: 3rem;
      padding: 1rem;

      .ccpay-Receipt-card {
        padding: 1rem;
        background: white;
        margin-bottom: 2rem;

        p {
          // padding: 1.5rem;
          padding-top: 1rem;
          font-size: .875rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-bottom: 0.5rem;
        }

        .ccpay-Receipt-t-switch {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .mint-switch-core {
          width: 42px;
          height: 22px;
        }

        .mint-switch-core::before {
          width: 40px;
          height: 20px;
        }

        .mint-switch-core::after {
          width: 20px;
          height: 20px;
        }

        .mint-switch-input:checked + .mint-switch-core {
          border-color: #D9B67E;
          background-color: #D9B67E;
        }

        .ccpay-Receipt-card-ipt {
          padding-bottom: 1rem;

          input {
            background: #F8F8F8;
            border: none;
            outline: none;
            padding: .6rem;
            width: 10rem;
          }
        }
      }
      // background: white;
      // height: 3rem;
    }
  }

    
</style>



// WEBPACK FOOTER //
// src/components/index/Receipt.vue